const PIPELINE_OPERATIONS_ROLES = new Set([
  "ADMIN",
  "SUPER_ADMIN",
  "TECHNICIAN",
  "ORG_ADMIN",
]);

export function canReadPipelineOperations(role?: string | null): boolean {
  if (!role) return false;
  return PIPELINE_OPERATIONS_ROLES.has(role.trim().toUpperCase());
}
